module.exports = __webpack_public_path__ + "img/footerIcon_1.0361a9a.png";